import { useEffect } from "react";
import {
  Stack,
  Checkbox,
  useCheckboxGroup,
  StackProps,
  FormErrorMessage,
} from "@chakra-ui/react";

type TOption = { label: string; value: string };

type TProps = StackProps & {
  options: TOption[];
  onChange: (val?: (string | number)[]) => void;
  error?: string;
  defaultValue?: string[];
};

export const CheckboxGroup: React.FC<TProps> = ({
  options,
  onChange,
  error,
  defaultValue,
  ...rest
}) => {
  const { value, getCheckboxProps } = useCheckboxGroup();

  useEffect(() => {
    if (value.length < 1) {
      onChange(undefined);
    } else {
      onChange(value);
    }
  }, [value]);

  return (
    <Stack gap="2.5" my="2.5" {...rest}>
      {options.map(({ value }) => (
        <Checkbox
          key={value}
          _checked={{
            bg: "#D7DEF8",
            borderColor: "#7147BD",
          }}
          cursor="pointer"
          bg="white"
          width="100%"
          borderWidth="1px"
          borderRadius="5px"
          fontSize="0.9rem"
          boxShadow="card"
          p="2.5"
          {...getCheckboxProps({ value })}
          isChecked={defaultValue?.includes(value)}>
          {value}
        </Checkbox>
      ))}
      {error && <FormErrorMessage>{error}</FormErrorMessage>}
    </Stack>
  );
};
